export const PLATFORM_LABELS = {
  MOKA_BACKOFFICE: 'Moka Backoffice',
  INTERNAL_TOOL: 'Odoo Internal Tools',
};
